module.exports = __webpack_public_path__ + "static/media/Team 23 - Unmask.97484011.png";